import React, { useEffect, useRef, useState } from "react";
import { showToast } from "../common/ToastProvider";
import "./TrackBogusPage.css"; // 👈 नया CSS file

const API_BASE = process.env.REACT_APP_API_URL || "";
const BATCH_SIZE = 25;

const TrackBogusPageTest = () => {
  const [votes, setVotes] = useState([]);
  const votesRef = useRef(votes);
  useEffect(() => {
    votesRef.current = votes;
  }, [votes]);

  const [userVote, setUserVote] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [totalVotes, setTotalVotes] = useState(null);
  const [highlightedId, setHighlightedId] = useState(null);

  const offsetRef = useRef(0);

  const checkUserVote = async () => {
    try {
      const url = `${API_BASE}/getBogusVotes.php?offset=0&limit=1`;
      const res = await fetch(url, { credentials: "include" });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      if (data && data.userVote) {
        setUserVote(data.userVote);
        return true;
      } else {
        if (!window.redirecting) {
          window.redirecting = true;
          showToast("You Need to cast your vote first", "warn");
          setTimeout(() => {
            window.location.href = "/";
          }, 5000);
        }
        return false;
      }
    } catch (err) {
      console.error("checkUserVote error:", err);
      return false;
    }
  };

  const fetchVotes = async () => {
    if (loading) return 0;
    if (!hasMore) return 0;

    setLoading(true);
    try {
      const url = `${API_BASE}/getBogusVotes.php?offset=${offsetRef.current}&limit=${BATCH_SIZE}`;
      const res = await fetch(url, { credentials: "include" });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      if (!data || data.success !== true) {
        setHasMore(false);
        return 0;
      }

      const fetched = Array.isArray(data.votes) ? data.votes : [];
      setVotes((prev) => {
        const existing = new Set(prev.map((v) => v.id));
        const filtered = fetched.filter((v) => !existing.has(v.id));
        return [...prev, ...filtered];
      });

      if (data.userVote) setUserVote(data.userVote);
      const tot = Number(data.totalVotes) || 0;
      setTotalVotes(tot);

      offsetRef.current = votesRef.current.length;

      if (offsetRef.current >= tot || fetched.length === 0) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }

      return fetched.length;
    } catch (err) {
      console.error("fetchVotes error:", err);
      showToast("Error loading votes", "warn");
      return 0;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      const hasVote = await checkUserVote();
      if (hasVote) {
        fetchVotes();
      }
    })();
  }, []);

  useEffect(() => {
    const onScroll = () => {
      if (loading || !hasMore) return;
      const scrollPos = window.innerHeight + window.scrollY;
      const threshold = document.documentElement.offsetHeight - 800;
      if (scrollPos >= threshold) {
        fetchVotes();
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [loading, hasMore]);

  const handleHighlight = async () => {
    if (!userVote) {
      showToast("No user vote found", "warn");
      return;
    }

    setHighlightedId(userVote.id);

    if (votesRef.current.find((v) => v.id === userVote.id)) {
      setTimeout(() => {
        const el = document.getElementById(`vote-row-${userVote.id}`);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);
      showToast("Your ID is Highlighted", "success");
      return;
    }

    if (userVote.rownum) {
      const batchIndex = Math.floor((userVote.rownum - 1) / BATCH_SIZE);
      const offset = batchIndex * BATCH_SIZE;

      try {
        const url = `${API_BASE}/getBogusVotes.php?offset=${offset}&limit=${BATCH_SIZE}`;
        const res = await fetch(url, { credentials: "include" });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();

        if (data && data.success) {
          setVotes(data.votes);
          setTimeout(() => {
            const el = document.getElementById(`vote-row-${userVote.id}`);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
          }, 200);
          showToast("Your vote is highlighted", "success");
        } else {
          showToast("Could not load your vote batch", "warn");
        }
      } catch (err) {
        console.error("Highlight fetch error:", err);
        showToast("Error loading your vote batch", "warn");
      }
    } else {
      showToast("Vote position not available", "warn");
    }
  };

  return (
    <div className="track-container">
      <div className="top-container sticky">
        <h2 className="track-title ">TRACK MY BOGUS VOTE</h2>
        {/* Search */}
        <div className="search-container sticky">
          <div className="search-text">CLICK ON SEARCH ICON</div>
          <div className="search-icon-group">
            <div className="icon-with-speaker">
              <button
                className="search-icon-button"
                onClick={handleHighlight}
                disabled={!userVote}
              >
                <img src="/images/search.jpg" alt="Search" width="30" />
              </button>
              <img src="/images/speaker.webp" alt="Speaker" width="30" />
            </div>

            <div className="search-label">SEARCH ICON</div>
          </div>
        </div>
        {/* {userVote && (
        <div className="search-section">
          <button className="search-btn" onClick={handleHighlight}>
            <span className="arrow">⬇</span> SEARCH ICON
          </button>
        </div>
      )} */}

        <div className="table-header">
          <div className="col-serial">SERIAL NO.</div>
          <div className="col-voter">VOTER REFERENCE ID</div>
        </div>
      </div>

      <div className="table-body">
        {votes.length === 0 && !loading ? (
          <div className="no-votes">No votes loaded yet</div>
        ) : (
          votes.map((v, idx) => {
            const isHighlighted = highlightedId === v.id;
            return (
              <div
                id={`vote-row-${v.id}`}
                key={v.id || idx}
                className="table-row"
              >
                <div className="col-serial">{v.rownum || idx + 1}</div>
                <div
                  className={`col-voter ${isHighlighted ? "highlight" : ""}`}
                >
                  {isHighlighted
                    ? v.mobile || v.masked_mobile
                    : v.masked_mobile || v.mobile}
                </div>
              </div>
            );
          })
        )}

        {loading &&
          [...Array(5)].map((_, i) => (
            <div key={`skeleton-${i}`} className="table-row skeleton">
              <div className="col-serial"></div>
              <div className="col-voter"></div>
            </div>
          ))}
      </div>

      {!hasMore && votes.length > 0 && (
        <div className="end-msg">No more votes</div>
      )}
    </div>
  );
};

export default TrackBogusPageTest;
